import React from 'react'
import _ from "underscore";

const Text  = function (props) {
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);
        
    if (childBlocks.length > 0) {
        return (
            <category name='Text' id='text' iconclass='category with-icon-paths snap-icon-text_dual'>
                <label text="Text"></label>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Text;